'use client';

import JobDetailsFloatingButtons from './job-details-floating-buttons';
import { useFavoriteStore } from '~/stores/favorite-store';
import { JobDetail } from '~/types/job-detail';

interface ClientJobDetailsFloatingButtonsProps {
  job: JobDetail;
  isSignedIn: boolean;
  jobApplicantsJobIds: number[];
  favoriteJobIds: number[];
  isMobile: boolean;
}

export function ClientJobDetailsFloatingButtons({
  job,
  isSignedIn,
  jobApplicantsJobIds,
  favoriteJobIds,
  isMobile,
}: ClientJobDetailsFloatingButtonsProps) {
  const { isFavorite } = useFavoriteStore();

  return (
    <JobDetailsFloatingButtons
      job={job}
      isSignedIn={isSignedIn}
      jobApplicantsJobIds={jobApplicantsJobIds}
      isFavorite={isFavorite(job.id)}
      favoriteJobIds={favoriteJobIds}
      isMobile={isMobile}
    />
  );
}
